<template>
  <div id="app" ref="app">
    <div class="progress-container" v-show="!loaded">
      <img class="load-logo" src="../src/assets/images/logo.svg">
      <b-progress :value="assetsLoaded * 100 / 23" size="is-medium"></b-progress>
      <div>{{ this.assetsLoaded }} / 23</div>
    </div>
    <div class="app-container" v-show="loaded">
      <div class="menu-container">
        <img class="left" src="../src/assets/images/logo.svg">
        <div class="mid"><span>{{timeMinSec[0]}}</span>:<span>{{timeMinSec[1]}}</span></div>
        <div class="right">
          <div class="buttons">
            <b-button type="is-primary" size="is-small" icon-right="undo-alt" v-on:click="reset" title="Reset"></b-button>
            <b-button type="is-info" size="is-small" icon-right="volume-up" title="Mute" v-show="!muted" v-on:click="mute" :disabled="isios"></b-button>
            <b-button type="is-info" size="is-small" icon-right="volume-mute" title="Unmute" v-show="muted" v-on:click="unmute" ></b-button>
            <b-button type="is-warning" size="is-small" icon-right="info" title="Info" v-on:click="showInfo = true" ></b-button>
          </div>
        </div>
      </div>
      <div class="game-container">
        <div class="stack" ref="stack" v-bind:style="computedStyle">
          <video autoplay muted playsinline loop preload="auto" ref="menuVid" class="item" v-bind:style="computedStyle" v-show="state === 0" draggable="false">
            <source src="../src/assets/videos/menu.mp4" type="video/mp4">
          </video>
          <div class="startmenu" v-show="state === 0">
            <div class="mb-2">Click on the hypnotic rings to keep your mind clear.</div>
            <b-button class="startmenu-button" type="is-light" v-on:click="start" title="Start">Start</b-button>
          </div>
          <canvas ref="canvasProgress" class="item" :width="dimensions[0]" :height="dimensions[1]" v-bind:style="computedStyle" v-show="state === 1" draggable="false"></canvas>
          <canvas ref="canvasKaa" class="item" :width="dimensions[0]" :height="dimensions[1]" v-bind:style="[computedStyle, kaaOpacity]" v-show="state === 1" draggable="false"></canvas>
          <video muted playsinline loop preload="auto" ref="gameoverVid" class="item" v-bind:style="[computedStyle]" v-show="state === 2" draggable="false">
            <source src="../src/assets/videos/gameover.mp4" type="video/mp4">
          </video>
          <canvas ref="canvasRings" class="item" :width="dimensions[0]" :height="dimensions[1]" v-bind:style="[computedStyle, ringsOpacity]" v-show="state > 0" draggable="false"></canvas>
          <div ref="rings" class="item" v-bind:style="[computedStyle, ringsGifOpacity]" style="z-index: 10;" draggable="false" v-show="state === 1"></div>
        </div>
      </div>
    </div>

    <b-modal v-model="showInfo" has-modal-card>
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">Cease to Resist v{{version}}</p>
          <button type="button" class="delete" v-on:click="showInfo = false"/>
        </header>
        <section class="modal-card-body">
          <div class="is-size-5 has-text-weight-bold">Difficulty</div>
          <div>
            <div class="container-slider">
              <b-slider :min="0.1" :max="1.9" :step="0.1" :tooltip="false" v-model="speed">
              <b-slider-tick :value="0.1">Easy</b-slider-tick>
              <b-slider-tick :value="1">Medium</b-slider-tick>
              <b-slider-tick :value="1.9">Hard</b-slider-tick>
            </b-slider>
            </div>
          </div>
          <div class="is-size-5 has-text-weight-bold mt-4">Made by Taro</div>
          <div class="is-flex is-flex-direction-row is-align-items-center">
            <b-icon pack="fab" icon="twitter-square" size="is-large"></b-icon>
            <a class="has-text-weight-bold" href="https://twitter.com/Tarolewd" target="_blank">@Tarolewd</a>
          </div>
          <div class="is-flex is-flex-direction-row is-align-items-center">
            <b-icon pack="fab" icon="discord" size="is-large"></b-icon>
            <a class="has-text-weight-bold" href="https://discord.com/invite/V2EKfyDpV6" target="_blank">Kaa's Treetop</a>
          </div>
          <div class="is-size-5 has-text-weight-bold mt-4">Sources</div>
          <div class="content">
            <ul class="mt-0">
              <li>'The Jungle Book' belongs to Disney</li>
              <li>'Kaa ASMR' by <a class="has-text-weight-bold" href="https://www.youtube.com/channel/UCdFPB-7oRVyT74kBaDwid5Q" target="_blank">m5a5e5</a></li>
              <li>'Hypnotic Rings' by <a class="has-text-weight-bold" href="https://www.youtube.com/channel/UC8xGQOErVZSlM3PRHjoMe0A" target="_blank">K VFX</a></li>
            </ul>
          </div>
        </section>
        <footer class="modal-card-foot"></footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
// import * as PIXI from 'pixi.js'

export default {
  name: 'App',
  data: function () {
    return {
      version: process.env.VUE_APP_VERSION,
      speed: 1,
      bodyWidth: 0,
      bodyHeight: 0,
      canvas: {},
      state: 0,
      counter: 0,
      time: 0,
      treshholds: {
        progress: false,
        rings: false
      },
      sounds: {},
      videos: {},
      images: {},
      rings: new Set(),
      assetsLoaded: 0,
      loaded: false,
      timeouts: {},
      muted: false,
      showInfo: false,
      isios: false,
      intervall: 1000,
      computedStyle: {},
      dimensions: [0, 0],
      ringsScale: 1,
      lastCounter: -1,
      lastRingsFrame: 0,
      lastKaaFrame: 0,
      lastProgressFrame: 0,
      frameKaa: 0,
      frameProgress: 0,
      frameRings: 0,
      gulpPlayed: false
    }
  },
  computed: {
    timeMinSec: function () {
      let minutes = Math.floor(this.time / 60)
      let seconds = this.time - minutes * 60
      if (minutes < 10) minutes = `0${minutes}`
      if (seconds < 10) seconds = `0${seconds}`
      return [minutes, seconds]
    },
    kaaOpacity: function () {
      return {
        opacity: 0.2 + this.counter / 150
      }
    },
    ringsOpacity: function () {
      return {
        opacity: (this.counter < 9 && !this.treshholds.rings) ? 0 : Math.max(1 / 200, (this.counter - 10) / 200)
      }
    },
    ringsGifOpacity: function () {
      return {
        opacity: 1 - this.counter / 77
      }
    }
  },
  watch: {
    assetsLoaded: async function () {
      if (this.assetsLoaded > 21) {
        await this.resizeImages()
        this.loaded = true
      }
    },
    speed: function () {
      if (window.localStorage) {
        window.localStorage.speed = this.speed
      }
    }
  },
  methods: {
    wait: function (ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    updateBodyDimensions: async function () {
      this.bodyWidth = document.body.offsetWidth
      this.bodyHeight = document.body.offsetHeight
      //
      const ratio = 1.7777777777777777
      let width = Math.min(1280, Math.floor((this.bodyWidth - 8)))
      let height = Math.floor(width * (1 / ratio))
      if (height > this.bodyHeight - 54) {
        height = Math.floor(this.bodyHeight - 54)
        width = Math.floor(height * ratio)
      }
      this.dimensions = [width, height]
      //
      this.computedStyle = {
        width: `${width}px`,
        height: `${height}px`
      }
      //
      if (this.loaded) await this.resizeImages()
      //
      const w = width / 900
      const h = height / 450
      this.ringsScale = Math.min(1, Math.min(w, h))
      const ringsWidth = Math.floor(80 * this.ringsScale)
      this.rings.forEach(rings => {
        rings.style.left = Math.floor(Math.random() * (width - ringsWidth)) + 'px'
        rings.style.top = Math.floor(Math.random() * (height - ringsWidth)) + 'px'
        rings.style.width = ringsWidth + 'px'
        rings.style.height = ringsWidth + 'px'
      })
    },
    resizeImages: async function () {
      const width = this.dimensions[0]
      const height = this.dimensions[1]
      const canvas = document.createElement('canvas')
      canvas.width = width
      canvas.height = height
      const ctx = canvas.getContext('2d', { alpha: false })
      this.images.progressresized = []
      for (let i = 0; i < 5; i++) {
        for (let j = 0; j < 15; j++) {
          ctx.drawImage(this.images.progress[i], 0, 720 * j, 1280, 720, 0, 0, width, height)
          const image = await createImageBitmap(canvas)
          this.images.progressresized.push(image)
        }
      }
      this.images.kaasized = []
      for (let i = 0; i < 4; i++) {
        for (let j = 0; j < 13; j++) {
          ctx.drawImage(this.images.kaa[i], 0, 720 * j, 1280, 720, 0, 0, width, height)
          const image = await createImageBitmap(canvas)
          this.images.kaasized.push(image)
        }
      }
      this.images.ringsresized = []
      for (let i = 0; i < 4; i++) {
        for (let j = 0; j < 16; j++) {
          ctx.drawImage(this.images.rings[i], 0, 720 * j, 1280, 720, 0, 0, width, height)
          const image = await createImageBitmap(canvas)
          this.images.ringsresized.push(image)
        }
      }
    },
    initImages: async function () {
      this.images.progress = []
      for (let i = 0; i < 5; i++) {
        const image = document.createElement('img')
        image.addEventListener('load', () => this.assetsLoaded++, { once: true })
        image.src = require(`../src/assets/images/progress/sprite-${i}.webp`)
        this.images.progress.push(image)
      }
      this.images.kaa = []
      for (let i = 0; i < 4; i++) {
        const image = document.createElement('img')
        image.addEventListener('load', () => this.assetsLoaded++, { once: true })
        image.src = require(`../src/assets/images/kaa/sprite-${i}.webp`)
        this.images.kaa.push(image)
      }
      this.images.rings = []
      for (let i = 0; i < 4; i++) {
        const image = document.createElement('img')
        image.addEventListener('load', () => this.assetsLoaded++, { once: true })
        image.src = require(`../src/assets/images/rings/sprite-${i}.webp`)
        this.images.rings.push(image)
      }
      this.images.ringsgif = []
      for (let i = 0; i < 3; i++) {
        const image = document.createElement('img')
        image.addEventListener('load', () => this.assetsLoaded++, { once: true })
        image.style.position = 'absolute'
        image.style.borderRadius = '50%'
        image.style.userSelect = 'none'
        image.setAttribute('draggable', false)
        image.src = require(`../src/assets/images/rings/rings-${i}.gif`)
        this.images.ringsgif.push(image)
      }
    },
    initSounds: function () { // 4
      ['gulp', 'ping', 'asmr', 'doom'].forEach(soundName => {
        const sound = new Audio()
        sound.preload = 'auto'
        sound.addEventListener('canplaythrough', () => this.assetsLoaded++, { once: true })
        sound.volume = 1
        sound.loop = soundName === 'asmr'
        sound.src = require(`../src/assets/sounds/${soundName}.mp3`)
        sound.load()
        this.sounds[soundName] = sound
      })
      this.isios = this.sounds.gulp.volume !== 1
    },
    initVideos: function () { // 3
      ['menu', 'gameover'].forEach(videoName => {
        const video = this.$refs[videoName + 'Vid']
        video.addEventListener('canplaythrough', () => this.assetsLoaded++, { once: true })
        if (videoName === 'gameover') {
          video.addEventListener('play', async () => {
            setTimeout(() => { this.sounds.doom.play() }, 500)
            while (this.counter < 210) {
              this.counter = this.counter + 3
              await this.wait(100)
            }
          })
          video.addEventListener('ended', () => {
            this.state = 3
          })
        }
        video.load()
        this.videos[videoName] = video
      })
    },
    addRings: async function () {
      if (this.state < 1) return
      const rnd = Math.floor(Math.random() * 3)
      const clone = this.images.ringsgif[rnd].cloneNode()
      const ringsWidth = Math.floor(80 * this.ringsScale)
      clone.style.left = Math.floor(Math.random() * (this.dimensions[0] - ringsWidth)) + 'px'
      clone.style.top = Math.floor(Math.random() * (this.dimensions[1] - ringsWidth)) + 'px'
      clone.style.width = ringsWidth + 'px'
      clone.style.height = ringsWidth + 'px'
      clone.addEventListener('mousedown', (event) => {
        event.preventDefault()
        event.stopImmediatePropagation()
        event.stopPropagation()
        this.rings.delete(clone)
        clone.remove()
        this.counter = this.counter - 1
      }, { once: true })
      clone.addEventListener('touchstart', (event) => {
        event.preventDefault()
        event.stopImmediatePropagation()
        event.stopPropagation()
        this.rings.delete(clone)
        clone.remove()
        this.counter = this.counter - 1
      }, { once: true })
      this.$refs.rings.appendChild(clone)
      this.rings.add(clone)
      this.counter = this.counter + 1
      if (this.counter > 74) {
        try {
          await Promise.all([
            this.sounds.ping.play(),
            this.videos.gameover.play()
          ])
          this.rings.forEach(rings => rings.remove())
          this.rings.clear()
        } catch (error) {
          console.error(error)
        } finally {
          this.state = 2
        }
        return
      }
      if (this.counter > 5 && !this.treshholds.rings) this.treshholds.rings = true
      if (this.counter === 65) {
        this.sounds.gulp.play()
        this.gulpPlayed = true
      }
      const intervall = Math.ceil((1000 - 300 * (Math.log(Math.floor(this.time / 5) + 1) / Math.log(3))) / this.speed)
      setTimeout(this.addRings, intervall)
    },
    startTimer: function () {
      this.timeouts.timer = setTimeout(() => {
        if (this.state !== 1) return
        this.time++
        this.startTimer()
      }, 1000)
    },
    initCanvas: function () {
      this.canvas.progressCtx = this.$refs.canvasProgress.getContext('2d', { alpha: false })
      this.canvas.kaaCtx = this.$refs.canvasKaa.getContext('2d', { alpha: false })
      this.canvas.ringsCtx = this.$refs.canvasRings.getContext('2d', { alpha: false })
    },
    animationFrame: function () {
      if (this.state === 0) return
      if (this.lastCounter !== this.counter && this.counter < 75) {
        this.canvas.progressCtx.drawImage(this.images.progressresized[this.counter], 0, 0)
        this.lastCounter = this.counter
      }
      const now = Date.now()
      /*
      if (this.state === 1 && now - this.lastProgressFrame > 130) {
        this.canvas.progressCtx.drawImage(this.images.progressresized[this.frameProgress], 0, 0)
        this.frameProgress = (this.frameProgress + 1) % 59
        this.lastProgressFrame = now
      }
      */
      if (this.state === 1 && now - this.lastKaaFrame > 80) {
        this.canvas.kaaCtx.drawImage(this.images.kaasized[this.frameKaa], 0, 0)
        this.frameKaa = (this.frameKaa + 1) % 52
        this.lastKaaFrame = now
      }
      if (now - this.lastRingsFrame > 40) {
        this.canvas.ringsCtx.drawImage(this.images.ringsresized[this.frameRings], 0, 0)
        this.frameRings = (this.frameRings + 1) % 64
        this.lastRingsFrame = now
      }
      requestAnimationFrame(this.animationFrame)
    },
    start: async function () {
      Object.values(this.sounds).forEach(sound => {
        sound.muted = true
      })
      await this.sounds.gulp.play()
      await this.sounds.gulp.pause()
      await this.sounds.ping.play()
      await this.sounds.ping.pause()
      await this.sounds.doom.play()
      await this.sounds.doom.pause()
      Object.values(this.sounds).forEach(sound => {
        sound.muted = this.muted
      })
      await Promise.all([
        this.videos.menu.pause(),
        this.sounds.asmr.play()
      ])
      this.state = 1
      this.animationFrame()
      this.addRings()
      this.startTimer()
    },
    reset: async function () {
      this.rings.forEach(rings => rings.remove())
      this.rings.clear()
      this.counter = 0
      this.time = 0
      this.lastCounter = -1
      this.lastRingsFrame = 0
      this.lastKaaFrame = 0
      this.lastProgressFrame = 0
      this.frameKaa = 0
      this.frameProgress = 0
      this.frameRings = 0
      this.treshholds.rings = false
      await Promise.all([
        this.sounds.doom.pause(),
        this.sounds.asmr.pause(),
        this.videos.gameover.pause()
      ])
      this.sounds.asmr.currentTime = 0
      this.videos.gameover.currentTime = 0
      this.videos.menu.currentTime = 0
      this.gulpPlayed = false
      await this.videos.menu.play()
      this.state = 0
    },
    mute: function () {
      Object.values(this.sounds).forEach(sound => {
        sound.muted = true
      })
      this.muted = true
    },
    unmute: function () {
      Object.values(this.sounds).forEach(sound => {
        sound.muted = false
      })
      this.muted = false
    }
  },
  mounted: async function () {
    this.updateBodyDimensions()
    let timeout = null
    window.addEventListener('resize', () => {
      clearTimeout(timeout)
      timeout = setTimeout(this.updateBodyDimensions, 500)
    })
    this.initImages()
    this.initSounds()
    this.initVideos()
    this.initCanvas()

    if (this.isios) {
      this.$buefy.dialog.alert({
        title: 'Limited browser support',
        message: 'Some features (e.g. audio, Game Over sequence) are not available.',
        type: 'is-danger',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.updateBodyDimensions)
  }
}
</script>

<style lang="scss">
.progress-container {
  width: 300px;
  margin: 0 auto;
  color: white;
  text-align: center;
  font-weight: bold;
  font-size: large;

  .progress-wrapper {
    margin-bottom: 0.5rem !important;
  }
}

.app-container {
  display: flex;
  flex-direction: column;
  max-width: 1920px;
  margin: 0 auto;
}

.menu-container {
  height: 50px;
  background-color: #383838;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
}

.game-container {
  margin: 0 auto;
  border-left: 4px solid #383838;
  border-right: 4px solid #383838;
  border-bottom: 4px solid #383838;
  background-color: #383838;
  overflow: hidden;

  video, canvas {
    display: block;
  }
}

.stack {
  user-select: none;
  position: relative;

  .item {
    user-select: none;
    position: absolute;
    top: 0;
    left: 0;
  }
}

.startmenu {
  font-size: 25px;
  width: 100%;
  color: rgb(240, 240, 240);
  position: absolute;
  text-align: center;
  bottom: 0;
  padding-bottom: 10px;
  padding-top: 5px;
  background-color: #383838a1;

  @media (max-width: 599px) {
    font-size: 20px;
    height: 90px;
  }

  @media (max-width: 499px) {
    font-size: 15px;
    height: 85px;
  }

  .startmenu-button {
    width: 130px;
    font-weight: bold;
  }
}

.left{
  width: 200px;
  margin-top: 5px;

  @media (max-width: 599px) {
    display: none;
  }
}

.mid {
  color: white;
  font-size: 22px;
  font-weight: 500;
  text-align: center;
  margin: 0 10px;

  @media (max-width: 599px) {
    margin: 0;
  }

  span {
    display: inline-block;
    width: 30px;
  }
}

.right {
  width: 200px;
  display: flex;
  justify-content: flex-end;

  .field {
    margin-bottom: 0 !important;
    margin-right: 0.25rem !important;
  }

  .is-warning {
    color: rgb(255, 255, 255) !important;
  }
}

.container-slider {
  margin: 0 15px;
  width: auto;
  height: 40px;
}
</style>
